import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {pickBy} from 'lodash'
import {userAPI} from '../app/api'
import {
    tokenDataHelper,
    userDataHelper,
} from '../helpers/localStorageHelper'
import {
    SignInDataType,
    UserDataType
} from './../types/userTypes'
import {AppStatusType} from './appStatusReducer'
import {AsyncThunkConfig, RootState} from './store'

interface InitialStateType {
    isLoggedIn: boolean
    userData: UserDataType
}

const initialState: InitialStateType = {
    isLoggedIn: !!userDataHelper.getUserData(),
    userData: userDataHelper.getUserData(),
}

export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setIsLoggedIn: (state, action: PayloadAction<boolean>) => {
            state.isLoggedIn = action.payload
        },
        setUserData: (state, action: PayloadAction<UserDataType>) => {
            state.userData = action.payload
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(LoginThunk.fulfilled, (state, action) => {
                state.isLoggedIn = true
                state.userData = pickBy(action.payload, (_, key) => key !== 'token') as UserDataType
                state.isLoggedIn = true
            })
            .addCase(SignOutThunk.fulfilled, (state) => {
                state.isLoggedIn = false
                state.userData = {} as UserDataType
            })
    }
})

export const {setIsLoggedIn, setUserData} = userSlice.actions

export const selectIsLoggedIn = (state: RootState): boolean => state.user.isLoggedIn
export const selectUserData = (state: RootState): UserDataType => state.user.userData
export const selectUsername = (state: RootState): string => state.user.userData.username


export const LoginThunk = createAsyncThunk<UserDataType, SignInDataType, AsyncThunkConfig>(
    'user/login',
    async (loginData, thunkAPI) => {
        try {
            const {status, data} = await userAPI.signIn(loginData)
            if (status === 200 && data) {
                userDataHelper.setUserData(pickBy(data, (_, key) => key !== 'token') as UserDataType)
                tokenDataHelper.setTokenData(data.token!)
                return thunkAPI.fulfillWithValue(data, {appStatus: AppStatusType.idle})
            } else {
                return thunkAPI.rejectWithValue(data)
            }
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error?.response?.data?.message)
        }
    }
)

export const SignOutThunk = createAsyncThunk<void, void, AsyncThunkConfig>(
    'user/signOut', 
    async (_, thunkAPI) => {

                userDataHelper.removeUserData()
                tokenDataHelper.removeTokenData()
                localStorage.clear()
                sessionStorage.clear()
                window.location.reload()

        return thunkAPI.fulfillWithValue(_, {appStatus: AppStatusType.idle})
    }
)

export default userSlice.reducer
 